import http from "./http";

class TypesService {
    getTypeById(id,token){
        return http.get(`/api/types/${id}`,{ headers: { 'Authorization': 'Bearer '+token } });
    }

    index(token){
        return http.get("/api/types",{ headers: { 'Authorization': 'Bearer '+token } })
    }

    store(data,token){
        return http.post("/api/types/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/types/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/types/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/types/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

}

export default new TypesService()